<template>
  <v-container v-if="lessons" class="px-0 mx-4">
    <v-row justify="space-between">
      <v-col cols="12">
        <template v-if="lessons">
          <v-row
            v-for="(lesson, index) in lessons"
            v-bind:key="'lesson' + index"
            height="100"
          >
            <v-card
              v-for="(exam, eIndex) in lesson.exams"
              :key="'exam' + eIndex"
              width="400"
              class="mx-2"
            >
              <v-card-title class="mx-4">
                {{ exam.name }}
              </v-card-title>
              <v-card-text class="mx-4">
                {{ exam.duration }} мин, {{ exam.finalScore }}
              </v-card-text>
              <v-card-actions class="mx-5">
                <p class="mr-10">
                  Авсан оноо:
                  <span
                    style="font-size: 12pt; color: red; font-weight: bold"
                    >{{ exam.result.totalScore }}</span
                  >
                </p>
                <v-spacer />
                <v-btn
                  small
                  dark
                  class="text-lowercase black--text"
                  v-if="exam.result && exam.result.examTaken"
                  color="yellow"
                  elevation="0"
                  :ripple="false"
                  @click="_showAnswer(exam)"
                  >Сорил өгсөн</v-btn
                >
                <v-btn
                  v-else
                  elevation="0"
                  color="red"
                  small
                  dark
                  @click.stop="_takeExam(lesson, exam)"
                  class="text-lowercase"
                  >Шалгалт өгөx</v-btn
                >
              </v-card-actions>
            </v-card>
          </v-row>
        </template>
      </v-col>
    </v-row>
  </v-container>
  <v-container v-else class="px-0">
    <v-card flat height="200">
      <h3 class="text-center accent--text">
        Танд одоогоор ямар нэгэн xичээл xуваарьлагдаагүй байна!
      </h3>
    </v-card>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import moment from "moment";
const fb = require("../../firebaseConfig.js");
export default {
  name: "RegularTablesView",
  data: () => ({
    willSearch: false,
    colWidth: 12,
    detailDialog: false,
    newDialog: false,

    deleteDialog: false,
    editedItem: {},
    editedIndex: -1,
    defaultItem: {},
    currentSelectedLessonStandart: {},
    selectedDepartment: null,
    messageNotification: null,

    bulkText: null,
    bulkDepartment: null,
  }),
  components: {},
  props: {
    lessons: {
      required: true,
      type: Array,
    },
    schoolPath: {
      required: true,
      type: String,
    },
    semester: {
      required: true,
      type: Object,
    },
    needToConfirmed: {
      default: false,
      type: Boolean,
    },
    withCreateButton: {
      default: false,
      type: Boolean,
    },
  },
  watch: {},
  computed: {
    ...mapState(["userProfile", "currentUser", "xxschool"]),
  },
  created() {},

  methods: {
    _showAnswer(exam){
      alert("Энэ шалгалтыг та өгсөн байна!")
    },
    _takeExam(lesson, exam) {
      console.log(lesson.ref.path, exam.ref.path);
      this.$router.push({
        name: "StudentTakeExam",
        params: {
          shalgaltIdd: exam.examRef.path,
          noRegister: true,
        },
      });
    },
    _getPath() {
      return this.schoolPath + "/lessons";
    },
  },
};
</script>
 